import React from 'react'
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner"
import Errors from "../Errors/Errors"
import I18n from 'i18n-js'

export default class ResetPassword extends React.Component {
  
  constructor(props) {
    super(props)
    
    this.state = {
      errors: [],
      success: false,
      loading: false,
      email: '',
      password: '',
      password_confirmation: '',
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onSilentSubmit = this.onSilentSubmit.bind(this)
  }

  render() {
    if (this.state.success) {
      return (
        <form onSubmit={this.onSilentSubmit} style={{position: 'relative'}}>
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            {I18n.t('password_updated_successfully')}
          </div>
          <hr />
          <div><a href={this.props.sign_in_path}>{I18n.t('sign_in')}</a></div>
        </form>
      )
    } else {
      return (
        <form onSubmit={this.onSubmit} style={{position: 'relative'}}>
          <Errors errors={this.state.errors} />
  
          {
            this.props.user || this.props.customer
            ?
            this.renderForm()
            :
            <Errors errors={[I18n.t('reset_password_token_used')]} />
          }
  
          <hr />
  
          <div><a href={this.props.sign_in_path}>{I18n.t('sign_in')}</a></div>
  
          <LoadingSpinner backgroundColor="rgba(32,33,46,0.5)" size="small" show={this.state.loading} />
        </form>
      )
    }
  }


  renderForm() {
    return (
      <div className="set-password-form">
          <label className="password-rules-label">
            {I18n.t('password_must')}
          </label>
          <ul className="password-rules-list">
            <li>{I18n.t('be_8_characters')}</li>
            <li>{I18n.t('contain_lowercase')}</li>
            <li>{I18n.t('contain_uppercase')}</li>
            <li>{I18n.t('contain_number')}</li>
            <li>{I18n.t('contain_symbol')}</li>
          </ul>
        <div className="form-group">
          <label>{I18n.t('password')}</label>
          <input type="password" name="password" className="form-control" value={this.state.password} onChange={this.onChange} />
        </div>

        <div className="form-group">
        <label>{I18n.t('password_confirmation')}</label>
          <input type="password" name="password_confirmation" className="form-control" value={this.state.password_confirmation} onChange={this.onChange} />
        </div>

        <div className="actions">
          <button type="submit" className="btn btn-primary">{I18n.t('set_my_password')}</button>
        </div>
      </div>
    )
  }

  onChange(e) {
    var { state } = this;
    state[e.target.name] = e.target.value
    this.setState(state);
  }

  onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.props.user || this.props.customer) {
      this.setState({loading: true})

      $.ajax({
        type: 'POST',
        url: this.props.forgot_password_path,
        data: {
          password: this.state.password,
          password_confirmation: this.state.password_confirmation
        }
      }).done((data) => {
        if (data.errors && data.errors.length) {
          this.setState({loading: false, errors: data.errors, success: false})
        } else {
          this.setState({loading: false, errors: [], success: true})
          //window.location.href = data.redirect_to
        }
      });
    }
  }

  onSilentSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
  }

}